import React, { useContext } from 'react';
import DOMPurify from 'dompurify';

import Button from './Button.jsx';

import TranslationsContext from '../TranslationsContext';

export default function InitPage({ sectionsAlreadyOnThePage, step, setStep }) {
	const t = useContext(TranslationsContext);

	return (
		<>
			<div className=" column small-12" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sectionsAlreadyOnThePage[1]) }} />
			<div className="subscriptions-configurator__buttons-wrapper column small-12 flex-container flex-dir-row align-spaced section-spacing-padding">
				<Button
					type="button"
					action={step + 1}
					setStep={setStep}
					text={t('start_here')}
					classname="button button--gradient-green text-size-large"
				/>
			</div>
		</>
	);
}
